<script>
	// Stores
	import SelectionStore from '@/Stores/Racing/SelectionStore.js';
	import { smallScreen } from '@/Stores/Store.js';
	import SelectionDetails from '@/Partials/Racing/Selections/_SelectionDetails.svelte';

	export let place;
	export let race;

	$: selection = $SelectionStore.firstWhere('id', place.selection_id.toString());

	// found here http://forums.shopify.com/categories/2/posts/29259
	const getGetOrdinal = function (n) {
		const s = ['th', 'st', 'nd', 'rd'],
			v = n % 100;
		return n + (s[(v - 20) % 10] || s[v] || s[0]);
	};
</script>

<div class="flex items-center text-xs">
	<span class="w-10 pr-2 font-bold text-center">
		{getGetOrdinal(place.position)}
	</span>
	<!-- <Silk {race} {selection} /> -->
	<SelectionDetails {race} {selection} showWeight={false} showJockeyTrainer={!$smallScreen} />
</div>
